import { SubmenuDivHandler } from './SubmenuDivHandler.js';
import { SceneController } from '../scene-controller.js';
import { EventsClient } from '../events-client.js';
import Logger from '../utils/logger.js';

const MODULE = 'SceneSubmenu';

const MM_SCENE_HTML = `
        <div id="menu-modal-scene" class="menu-modal-content">
            <h2>Scene</h2>
            <p>Choose a scene to request for all users</p>
            <select id="mm-scene-select" class="mm-text-input" onkeydown="event.stopPropagation()"></select>
            <div>
                <button id="mm-scene-switch-button" class="mm-submit-button" hidden>Switch Scene</button>
            </div>
        </div>
`;

export class SceneSubmenuDH extends SubmenuDivHandler {
    static TypeName = 'SceneSubmenuDH';
    private cooldownTimer: number | null = null;

    private ensureCooldownTimer() {
        if (this.cooldownTimer !== null) {
            return;
        }

        this.cooldownTimer = window.setInterval(() => {
            this.updateConditionals();
        }, 1000);
    }

    private clearCooldownTimer() {
        if (this.cooldownTimer !== null) {
            window.clearInterval(this.cooldownTimer);
            this.cooldownTimer = null;
        }
    }

    updateConditionals(): void {
        const sceneController = SceneController.instance;
        const sceneSelect = document.getElementById('mm-scene-select') as HTMLSelectElement | null;
        const switchButton = document.getElementById('mm-scene-switch-button') as HTMLButtonElement | null;

        if (!sceneController || !sceneSelect || !switchButton) {
            return;
        }

        const selectedSceneRef = sceneSelect.value;
        const currentSceneRef = sceneController.currentSceneRef;
        const shouldShowSwitch = Boolean(selectedSceneRef) && selectedSceneRef !== currentSceneRef;
        const cooldownRemainingSeconds = EventsClient.instance.getSceneSwitchCooldownRemainingSeconds();

        //Logger.debug(MODULE, `updateConditionals: selected="${selectedSceneRef}", current="${currentSceneRef}", shouldShow=${shouldShowSwitch}`);

        switchButton.style.display = shouldShowSwitch ? 'inline-flex' : 'none';
        switchButton.disabled = cooldownRemainingSeconds > 0;
        
        if (!shouldShowSwitch) {
            switchButton.innerText = 'Switch Scene';
            return;
        }

        if (cooldownRemainingSeconds > 0) {
            switchButton.innerText = `Wait ${cooldownRemainingSeconds}s`;
        } else {
            switchButton.innerText = 'Switch Scene';
        }
    }

    displayMenuContent(containerDiv: HTMLDivElement): void {
        containerDiv.innerHTML = MM_SCENE_HTML;

        const sceneController = SceneController.instance;
        if (!sceneController) {
            Logger.error(MODULE, 'SceneController singleton not available.');
            return;
        }

        const sceneSelect = document.getElementById('mm-scene-select') as HTMLSelectElement | null;
        const switchButton = document.getElementById('mm-scene-switch-button') as HTMLButtonElement | null;
        if (!sceneSelect || !switchButton) {
            Logger.error(MODULE, 'Missing scene submenu elements.');
            return;
        }

        sceneSelect.innerHTML = '';
        for (const sceneRef of sceneController.sceneRefs) {
            const option = document.createElement('option');
            option.value = sceneRef;
            option.innerText = sceneRef;
            sceneSelect.appendChild(option);
        }

        const currentSceneRef = sceneController.currentSceneRef;
        if (currentSceneRef && sceneController.sceneRefs.includes(currentSceneRef)) {
            sceneSelect.value = currentSceneRef;
        }

        sceneSelect.addEventListener('change', () => {
            this.updateConditionals();
        });

        switchButton.addEventListener('click', () => {
            const selectedSceneRef = sceneSelect.value;
            if (EventsClient.instance.getSceneSwitchCooldownRemainingSeconds() > 0) {
                this.updateConditionals();
                return;
            }

            if (!selectedSceneRef || selectedSceneRef === sceneController.currentSceneRef) {
                this.updateConditionals();
                return;
            }

            EventsClient.instance.requestSceneSwitch(selectedSceneRef);
        });

        this.updateConditionals();
        this.ensureCooldownTimer();
    }

    hideContent(): void {
        this.clearCooldownTimer();

        const sceneSelect = document.getElementById('mm-scene-select') as HTMLSelectElement | null;
        const switchButton = document.getElementById('mm-scene-switch-button') as HTMLButtonElement | null;

        const newSelect = sceneSelect?.cloneNode(true);
        if (sceneSelect && newSelect) {
            sceneSelect.parentNode?.replaceChild(newSelect, sceneSelect);
        }

        const newSwitchButton = switchButton?.cloneNode(true);
        if (switchButton && newSwitchButton) {
            switchButton.parentNode?.replaceChild(newSwitchButton, switchButton);
        }
    }
}